<template>
    <section class="listings" v-bind:data-mode="$store.state.mode">
        <div
            class="listings__loader"
            v-bind:class="$store.state.loader ? 'active' : ''"
        >
            <div class="listings__loader-inner">
                <h5 class="listings__loader-title">Looking for Listings</h5>

                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div class="listings__inner" v-if="$store.state.initialized">
            <div class="listings__filtering">
                <h3 class="listings__filtering-title">Filter Listings</h3>

                <div
                    class="listings__filtering-fields"
                    v-if="$store.state.mode === 'sale'"
                >
                    <!-- SALES MODE --->
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-resort"
                            class="listings__filtering-field-label"
                        >Resort</label
                        >
                        <select
                            id="listings__filtering-field-sale-resort"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.resort"
                        >
                            <option value="null">All</option>
                            <option
                                v-for="(resort, resort_index) in $store.state.datasets.resorts"
                                v-bind:key="resort_index"
                                v-bind:value="resort.id"
                            >
                                {{ resort.name }}
                            </option>
                            <!-- <option v-for="( resort, resort_index ) in $store.state.datasets.resorts.filter(x => x.brand==10)" v-bind:key="resort_index" v-bind:value="resort.id">{{ resort.name }}</option> -->
                        </select>
                    </div>
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-status"
                            class="listings__filtering-field-label"
                        >Status</label
                        >
                        <select
                            id="listings__filtering-field-sale-status"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.status"
                        >
                            <option value="null">Any</option>
                            <option
                                v-for="(status, status_index) in $store.state.datasets.statuses"
                                v-bind:key="status_index"
                                v-bind:value="status.id"
                            >
                                {{ status.name }}
                            </option>
                        </select>
                    </div>
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-owner"
                            class="listings__filtering-field-label"
                        >Owner</label
                        >
                        <input
                            id="listings__filtering-field-sale-owner"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.owner"
                        />
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-use-year"
                            class="listings__filtering-field-label"
                        >Use Year</label
                        >
                        <select
                            id="listings__filtering-field-sale-use-year"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.use_year"
                        >
                            <option value="null">All</option>
                            <option
                                v-for="(use_year, use_year_index) in $store.state.datasets
                                    .use_years"
                                v-bind:key="use_year_index"
                                v-bind:value="use_year.id"
                            >
                                {{ use_year.name }}
                            </option>
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-max-points"
                            class="listings__filtering-field-label"
                        >Points (Maximum)</label
                        >
                        <select
                            id="listings__filtering-field-sale-max-points"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.max_points"
                        >
                            <option value="null">Any (No Maximum)</option>
                            <option
                                v-for="(points, points_index) in $store.state.datasets
                                    .max_points"
                                v-bind:key="points_index"
                                v-bind:value="points"
                            >
                                {{ points }}
                            </option>
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-max-ppp"
                            class="listings__filtering-field-label"
                        >$/Point (Maximum)</label
                        >
                        <select
                            id="listings__filtering-field-sale-max-ppp"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.max_ppp"
                        >
                            <option value="null">Any (No Maximum)</option>
                            <option
                                v-for="(ppp, ppp_index) in $store.state.datasets.max_ppp_resale"
                                v-bind:key="ppp_index"
                                v-bind:value="ppp * 10"
                            >
                                ${{ ppp * 10 }}
                            </option>
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-max-price"
                            class="listings__filtering-field-label"
                        >Total Price</label
                        >
                        <select
                            id="listings__filtering-field-sale-max-price"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.max_price"
                        >
                            <option value="null">Any (No Maximum)</option>
                            <option
                                v-for="(price, price_index) in $store.state.datasets.max_prices"
                                v-bind:key="price_index"
                                v-bind:value="price * 1000"
                            >
                                ${{ price * 1000 }}
                            </option>
                        </select>
                    </div>
                </div>

                <div
                    class="listings__filtering-fields"
                    v-if="$store.state.mode === 'rent'"
                >
                    <!-- RENTAL MODE --->
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-rent-subtype"
                            class="listings__filtering-field-label"
                        >Type</label
                        >
                        <select
                            id="listings__filtering-field-rent-subtype"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.subtype"
                        >
                            <option value="null">All</option>
                            <option
                                v-for="(
                                    subtype, subtype_index
                                ) in $store.state.datasets.subtypes.filter((x) => x.id != 41)"
                                v-bind:key="subtype_index"
                                v-bind:value="subtype.id"
                            >
                                {{ subtype.name }}
                            </option>
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-rent-resort"
                            class="listings__filtering-field-label"
                        >Resort</label
                        >
                        <select
                            id="listings__filtering-field-rent-resort"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.resort"
                        >
                            <option value="null">All</option>
                            <option
                                v-for="(resort, resort_index) in $store.state.datasets.resorts"
                                v-bind:key="resort_index"
                                v-bind:value="resort.id"
                            >
                                {{ resort.name }}
                            </option>
                            <!-- <option v-for="( resort, resort_index ) in $store.state.datasets.resorts.filter(x => x.brand==10)" v-bind:key="resort_index" v-bind:value="resort.id">{{ resort.name }}</option> -->
                        </select>
                    </div>
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-sale-status"
                            class="listings__filtering-field-label"
                        >Status</label
                        >
                        <select
                            id="listings__filtering-field-sale-status"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.status"
                        >
                            <option value="null">Any</option>
                            <option
                                v-for="(status, status_index) in $store.state.datasets.statuses"
                                v-bind:key="status_index"
                                v-bind:value="status.id"
                            >
                                {{ status.name }}
                            </option>
                        </select>
                    </div>
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-rent-owner"
                            class="listings__filtering-field-label"
                        >Owner</label
                        >
                        <input
                            id="listings__filtering-field-rent-owner"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.owner"
                        />
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-rent-use_year_rental"
                            class="listings__filtering-field-label"
                        >Use Year</label
                        >
                        <select
                            id="listings__filtering-field-rent-use_year_rental"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.use_year_rental"
                        >
                            <option value="null">All</option>
                            <option
                                v-for="(use_year_rental, use_year_rental_index) in $store.state
                                    .datasets.use_year_rental"
                                v-bind:key="use_year_rental_index"
                                v-bind:value="use_year_rental.id"
                            >
                                {{ use_year_rental.name }}
                            </option>
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-rent-max-points"
                            class="listings__filtering-field-label"
                        >Points (Maximum)</label
                        >
                        <select
                            id="listings__filtering-field-rent-max-points"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.max_points"
                        >
                            <option value="null">Any (No Maximum)</option>
                            <option
                                v-for="(points, points_index) in $store.state.datasets
                                    .max_points"
                                v-bind:key="points_index"
                                v-bind:value="points"
                            >
                                {{ points }}
                            </option>
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-rent-max-ppp"
                            class="listings__filtering-field-label"
                        >$/Point (Maximum)</label
                        >
                        <select
                            id="listings__filtering-field-rent-max-ppp"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.max_ppp"
                        >
                            <option value="null">Any (No Maximum)</option>
                            <option
                                v-for="(ppp, ppp_index) in $store.state.datasets.max_ppp_rental"
                                v-bind:key="ppp_index"
                                v-bind:value="ppp * 10"
                            >
                                ${{ ppp * 10 }}
                            </option>
                        </select>
                    </div>

                    <!-- REMOVED: Size filter field -->
                    <!-- REMOVED: Travel Dates filter field -->
                </div>

                <div
                    class="listings__filtering-fields"
                    v-if="$store.state.mode === 'swap'"
                >
                    <!-- SWAP MODE -->
                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-swap-resort"
                            class="listings__filtering-field-label"
                        >Resort I Own</label
                        >
                        <select
                            id="listings__filtering-field-swap-resort"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.resort"
                        >
                            <option value="null">All</option>
                            <option value="-10">Any DVC</option>
                            <!--<option value="-20">Any Marriott</option> -->
                            <option
                                v-for="(resort, resort_index) in $store.state.datasets.resorts"
                                v-bind:key="resort_index"
                                v-bind:value="resort.id"
                            >
                                {{ resort.name }}
                            </option>
                            <!-- <option v-for="( resort, resort_index ) in $store.state.datasets.resorts.filter(x => x.brand==10)" v-bind:key="resort_index" v-bind:value="resort.id">{{ resort.name }}</option> -->
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-swap-resort-desired"
                            class="listings__filtering-field-label"
                        >Resort I Want</label
                        >
                        <select
                            id="listings__filtering-field-swap-resort-desired"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.resort_desired"
                        >
                            <option value="null">All</option>
                            <option value="-10">Any DVC</option>
                            <!--<option value="-20">Any Marriott</option> -->
                            <option
                                v-for="(resort, resort_index) in $store.state.datasets.resorts"
                                v-bind:key="resort_index"
                                v-bind:value="resort.id"
                            >
                                {{ resort.name }}
                            </option>
                            <!-- <option v-for="( resort, resort_index ) in $store.state.datasets.resorts.filter(x => x.brand==10)" v-bind:key="resort_index" v-bind:value="resort.id">{{ resort.name }}</option> -->
                        </select>
                    </div>

                    <div class="listings__filtering-field">
                        <label
                            for="listings__filtering-field-swap-size"
                            class="listings__filtering-field-label"
                        >Size</label
                        >
                        <select
                            id="listings__filtering-field-swap-size"
                            class="listings__filtering-field-filter"
                            v-model="$store.state.selections.size"
                        >
                            <option value="null">Any</option>
                            <option
                                v-for="(size, size_index) in $store.state.datasets.sizes"
                                v-bind:key="size_index"
                                v-bind:value="size.id"
                            >
                                {{ size.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <button
                    type="button"
                    class="btn btn-quaternary btn-sm w-100"
                    v-on:click="$store.dispatch('refresh')"
                >
                    Filter
                </button>
            </div>

            <div class="listings__results">
                <h3
                    class="listings__results-quick-title"
                    v-html="$store.state.title"
                ></h3>

                <div class="listings__results-table-notice">
                    <p>
                        <i class="fal fa-info-circle" aria-hidden="true"></i> Click on a
                        column heading to sort the results to your choosing. To view more
                        columns, turn your mobile device to landscape (horizontal) mode.
                    </p>
                </div>

                <table
                    class="listings__results-table"
                    v-if="$store.state.response.length"
                >
                    <!-- Updated colgroup for rental mode -->
                    <colgroup v-if="$store.state.mode === 'rent'">
                        <col class="col-resort" />
                        <col class="col-points" />
                        <col class="col-ppp" />
                        <col class="col-price" />
                        <col class="col-subtype" />
                        <col class="col-use_year_rental" />
                        <col class="col-status" />
                        <col class="col-owner" />
                    </colgroup>

                    <!-- Colgroup for resale mode -->
                    <colgroup v-if="$store.state.mode === 'sale'">
                        <col class="col-resort" />
                        <col class="col-points" />
                        <col class="col-availability" />
                        <col class="col-use-year" />
                        <col class="col-ppp" />
                        <col class="col-price" />
                        <col class="col-status" />
                        <col class="col-owner" />
                    </colgroup>

                    <thead>
                        <tr>
                            <!-- RENTAL MODE COLUMNS -->
                            <!-- Resort - shown on all viewports for rental -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--resort"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('resort')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'resort',
                                }"
                            >
                                <span>Resort</span>
                            </th>

                            <!-- Points - shown on all viewports for rental -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--points"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('points')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'points',
                                }"
                            >
                                <span>Pts.</span>
                            </th>

                            <!-- $/Point - shown on all viewports for rental -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--ppp"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('ppp')"
                                v-bind:class="{ is_sorted: $store.state.sort_key === 'ppp' }"
                            >
                                <span>$/Pt.</span>
                            </th>

                            <!-- Total Money - now shown on mobile -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--price hide-portrait-only"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('price')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'price',
                                }"
                            >
                                <span>$ Total</span>
                            </th>

                            <!-- Type - desktop only for rental -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--subtype hide-mobile"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('subtype')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'subtype',
                                }"
                            >
                                <span>Type</span>
                            </th>

                            <!-- Use Year - now shown on mobile -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--use_year_rental hide-portrait-only"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('use_year_rental')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'use_year_rental',
                                }"
                            >
                                <span>Use Year</span>
                            </th>

                            <!-- Status - portrait only for rental, hidden in landscape -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--status hide-mobile-landscape"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('status')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'status',
                                }"
                            >
                                <span>Status</span>
                            </th>

                            <!-- Owner - desktop and landscape only for rental -->
                            <th
                                v-if="$store.state.mode === 'rent'"
                                class="sortable type--owner hide-portrait-only"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('owner')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'owner',
                                }"
                            >
                                <span>Owner</span>
                            </th>

                            <!-- RESALE MODE COLUMNS -->
                            <!-- Resort - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--resort"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('resort')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'resort',
                                }"
                            >
                                <span>Resort</span>
                            </th>

                            <!-- Points - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--points"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('points')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'points',
                                }"
                            >
                                <span>Pts.</span>
                            </th>

                            <!-- Availability - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--availability"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('availability')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'availability',
                                }"
                            >
                                <span>Avail.</span>
                            </th>

                            <!-- Use Year - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--use-year"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('use-year')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'use-year',
                                }"
                            >
                                <span>Use Year</span>
                            </th>

                            <!-- $/Point - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--ppp"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('ppp')"
                                v-bind:class="{ is_sorted: $store.state.sort_key === 'ppp' }"
                            >
                                <span>$/Pt.</span>
                            </th>

                            <!-- Total Price - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--price hide-portrait"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('price')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'price',
                                }"
                            >
                                <span>$ Total</span>
                            </th>

                            <!-- Status - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--status hide-portrait"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('status')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'status',
                                }"
                            >
                                <span>Status</span>
                            </th>

                            <!-- Owner - resale mode -->
                            <th
                                v-if="$store.state.mode === 'sale'"
                                class="sortable type--owner hide-mobile"
                                v-bind:data-direction="$store.state.sort_order"
                                v-on:click="sort_table('owner')"
                                v-bind:class="{
                                    is_sorted: $store.state.sort_key === 'owner',
                                }"
                            >
                                <span>Owner</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(listing, listing_index) in $store.state.response"
                            v-bind:key="listing_index"
                        >
                            <!-- RENTAL MODE COLUMNS -->
                            <!-- Resort - shown on all viewports for rental -->
                            <td v-if="$store.state.mode === 'rent'" class="type--resort">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >
                                    {{ format_field_from_dataset("resort", listing.id_resort) }}
                                    <span class="id"
                                    >ID:
                                        <strong
                                        >#DVCA{{ listing.id_account }}-{{ listing.id }}</strong
                                        ></span
                                    >
                                </a>
                            </td>

                            <!-- Points - shown on all viewports for rental -->
                            <td v-if="$store.state.mode === 'rent'" class="type--points">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{ listing.points || "&mdash;" }}</a
                                >
                            </td>

                            <!-- $/Point - shown on all viewports for rental -->
                            <td v-if="$store.state.mode === 'rent'" class="type--ppp">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >${{ listing.cost_per_point || "&mdash;" }}</a
                                >
                            </td>

                            <!-- Total Money - now shown on mobile -->
                            <td
                                v-if="$store.state.mode === 'rent'"
                                class="type--price hide-portrait-only"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >${{ listing.cost || "&mdash;" }}</a
                                >
                            </td>

                            <!-- Type - desktop only for rental -->
                            <td
                                v-if="$store.state.mode === 'rent'"
                                class="type--subtype hide-mobile"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                ><span
                                    class="subtype"
                                    v-bind:data-type="
                                        format_field_from_dataset(
                                            'subtype',
                                            listing.id_subtype,
                                            true
                                        )
                                    "
                                >{{
                                    format_field_from_dataset(
                                        "subtype",
                                        listing.id_subtype,
                                        false
                                    )
                                }}</span
                                ></a
                                >
                            </td>

                            <!-- Use Year - now shown on mobile -->
                            <td
                                v-if="$store.state.mode === 'rent'"
                                class="type--use_year_rental hide-portrait-only"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{
                                    format_field_from_dataset(
                                        "use_year_rental",
                                        listing.use_year_rental,
                                        false
                                    )
                                }}</a
                                >
                            </td>

                            <!-- Status - hidden on mobile landscape to save space -->
                            <td
                                v-if="$store.state.mode === 'rent'"
                                class="type--status hide-landscape-only"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                ><span
                                    class="status"
                                    v-bind:data-status="
                                        format_field_from_dataset('status', listing.status, true)
                                    "
                                >{{
                                    format_field_from_dataset("status", listing.status, false)
                                }}</span
                                ></a
                                >
                            </td>

                            <!-- Owner - desktop and landscape only for rental -->
                            <td
                                v-if="$store.state.mode === 'rent'"
                                class="type--owner hide-portrait-only"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{ listing.owner || "&mdash;" }}</a
                                >
                            </td>

                            <!-- RESALE MODE COLUMNS -->
                            <!-- Resort - resale mode -->
                            <td v-if="$store.state.mode === 'sale'" class="type--resort">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >
                                    {{ format_field_from_dataset("resort", listing.id_resort) }}
                                    <span class="id"
                                    >ID:
                                        <strong
                                        >#DVCA{{ listing.id_account }}-{{ listing.id }}</strong
                                        ></span
                                    >
                                </a>
                            </td>

                            <!-- Points - resale mode -->
                            <td v-if="$store.state.mode === 'sale'" class="type--points">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{ listing.points || "&mdash;" }}</a
                                >
                            </td>

                            <!-- Availability - resale mode -->
                            <td
                                v-if="$store.state.mode === 'sale'"
                                class="type--availability"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{ listing.points_bucket_1 || "0" }}/{{
                                    listing.points_bucket_2 || "0"
                                }}/{{ listing.points_bucket_3 || "0" }}</a
                                >
                            </td>

                            <!-- Use Year - resale mode -->
                            <td v-if="$store.state.mode === 'sale'" class="type--use-year">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{
                                    format_field_from_dataset(
                                        "use-year",
                                        listing.use_year,
                                        false
                                    )
                                }}</a
                                >
                            </td>

                            <!-- $/Point - resale mode -->
                            <td v-if="$store.state.mode === 'sale'" class="type--ppp">
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >${{ listing.cost_per_point || "&mdash;" }}</a
                                >
                            </td>

                            <!-- Total Price - resale mode -->
                            <td
                                v-if="$store.state.mode === 'sale'"
                                class="type--price hide-portrait"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >${{ listing.cost || "&mdash;" }}</a
                                >
                            </td>

                            <!-- Status - resale mode -->
                            <td
                                v-if="$store.state.mode === 'sale'"
                                class="type--status hide-portrait"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                ><span
                                    class="status"
                                    v-bind:data-status="
                                        format_field_from_dataset('status', listing.status, true)
                                    "
                                >{{
                                    format_field_from_dataset("status", listing.status, false)
                                }}</span
                                ></a
                                >
                            </td>

                            <!-- Owner - resale mode -->
                            <td
                                v-if="$store.state.mode === 'sale'"
                                class="type--owner hide-mobile"
                            >
                                <a
                                    v-bind:href="
                                        '/listing/DVCA' + listing.id_account + '-' + listing.id
                                    "
                                    target="_blank"
                                >{{ listing.owner || "&mdash;" }}</a
                                >
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="alert alert-info" v-if="!$store.state.response">
                    <h4>Sorry!</h4>
                    <p class="mb-0">
                        No listings were found with the search criteria you have specified.
                        Adjust your search criteria using the filtering options and try
                        again.
                    </p>
                </div>
            </div>
        </div>

        <div
            class="listings__detail"
            v-if="$store.state.detail"
            v-html="$store.state.detail"
        ></div>

        <div class="listings__version" v-if="$store.state.initialized">
            <small>DVCA Listings, v{{ $store.state.version }}-vjs-prod</small>
        </div>
    </section>
</template>
<style scoped>
/* Updated Rental mode column configuration */
.listings[data-mode="rent"] .listings__results-table {
  /* Desktop - show all columns */
  @media screen and (min-width: 1024px) {
    .hide-mobile,
    .hide-portrait-only,
    .hide-landscape-only {
      display: table-cell !important;
    }
  }

  /* Mobile - differentiate between portrait and landscape */
  @media screen and (max-width: 1023px) {
    /* Always hide these on mobile */
    .hide-mobile {
      display: none !important;
    }

    /* Portrait only */
    @media (orientation: portrait) {
      .hide-portrait-only {
        display: none !important;
      }

      /* Show Status in portrait mode */
      .hide-landscape-only {
        display: table-cell !important;
      }

      /* Portrait: Resort, Points, $/Pt, Status (4 columns) */
      col.col-resort {
        width: 35% !important;
      }
      col.col-points {
        width: 15% !important;
      }
      col.col-ppp {
        width: 25% !important;
      }
      col.col-status {
        /* width: 25% !important; */
      }

      /* Hide columns not shown in portrait */
      col.col-price,
      col.col-use_year_rental,
      col.col-subtype,
      col.col-owner {
        display: none !important;
      }

      /* Hide cells not shown in portrait */
      th.type--price,
      th.type--use_year_rental,
      th.type--subtype,
      th.type--owner,
      td.type--price,
      td.type--use_year_rental,
      td.type--subtype,
      td.type--owner {
        display: none !important;
      }
    }

    /* Landscape */
    @media (orientation: landscape) {
      .hide-portrait-only {
        display: table-cell !important;
      }

      /* Hide Status in landscape mode to save space */
      .hide-landscape-only {
        display: none !important;
      }

      /* Landscape: Resort, Points, $/Pt, Total Money, Use Year, Owner (6 columns) */
      col.col-resort {
        width: 25% !important;
      }
      col.col-points {
        width: 12% !important;
      }
      col.col-ppp {
        width: 15% !important;
      }
      col.col-price {
        width: 18% !important;
      }
      col.col-use_year_rental {
        width: 15% !important;
      }
      col.col-owner {
        width: 15% !important;
      }

      /* Hide desktop-only columns and Status */
      col.col-subtype,
      col.col-status {
        display: none !important;
      }

      /* Hide cells */
      th.type--subtype,
      th.type--status,
      td.type--subtype,
      td.type--status {
        display: none !important;
      }
    }
  }
}

/* Base hide classes */
@media screen and (max-width: 1023px) {
  .hide-mobile {
    display: none !important;
  }

  @media (orientation: portrait) {
    .hide-portrait {
      display: none !important;
    }
  }
}

/* Ensure table uses full width */
.listings__results-table {
  table-layout: fixed !important;
  width: 100% !important;
  max-width: 100% !important;
}

/* Small screens */
@media screen and (max-width: 575px) {
  .listings__results-table {
    font-size: 11px;

    th,
    td {
      padding: 3px !important;
    }
  }
}
</style>
<script>
export default {
  name: "ListingsSearch",
  mounted: function () {
    this.$store.dispatch("initialize");
    this.sort_table("status");
    this.$store.state.selections.status = 1;
  },
  methods: {
    sort_table: function (key) {
      if (this.$store.state.sort_key === key) {
        this.$store.commit("set_value", {
          attribute: "sort_order",
          data: this.$store.state.sort_order === "asc" ? "desc" : "asc",
        });
      } else {
        this.$store.commit("set_value", {
          attribute: "sort_order",
          data: "asc",
        });
      }

      this.$store.commit("set_value", { attribute: "sort_key", data: key });

      let sort_key = this.$store.state.sort_key;
      let sort_order = this.$store.state.sort_order;
      let contents = this.$store.state.response;
      let formatter = this.format_field_from_dataset;

      contents.sort(function (left, right) {
        let result = false;

        switch (sort_key) {
          case "type":
            result =
              formatter("type", left.id_type, false) >
              formatter("type", right.id_type, false);
            break;

          case "subtype":
            result =
              formatter("subtype", left.id_subtype, false) >
              formatter("subtype", right.id_subtype, false);
            break;

          case "status":
            result =
              formatter("status", left.status, false) >
              formatter("status", right.status, false);
            break;

          case "resort":
            result =
              formatter("resort", left.id_resort) >
              formatter("resort", right.id_resort);
            break;

          case "resort-desired":
            result =
              formatter("resort", left.id_resort_desired) >
              formatter("resort", right.id_resort_desired);
            break;

          case "size":
            result =
              formatter("size", left.id_size, false) >
              formatter("size", right.id_size, false);
            break;

          case "use-year":
            result = left.use_year > right.use_year;
            break;

          case "use_year_rental":
            result = left.use_year_rental > right.use_year_rental;
            break;

          case "points":
            result = left.points > right.points;
            break;

          case "availability":
            result = left.points_bucket_1 > right.points_bucket_1;
            break;

          case "ppp":
            result = left.cost_per_point > right.cost_per_point;
            break;

          case "price":
            result = left.cost > right.cost;
            break;

          case "travel-dates":
            result = left.date_travel_start > right.date_travel_start;
            break;
        }

        if (!result) {
          return sort_order === "desc" ? 1 : -1;
        } else if (result) {
          return sort_order === "desc" ? -1 : 1;
        }

        return 0;
      });

      this.$store.commit("set_value", {
        attribute: "response",
        data: contents,
      });
    },

    format_field_from_dataset: function (type, value, to_lowercase) {
      let dataset = "";
      let result = "";

      switch (type) {
        case "use-year":
          dataset = "use_years";
          break;

        case "use_year_rental":
          dataset = "use_year_rental";
          break;

        case "size":
          dataset = "sizes";
          break;

        case "status":
          dataset = "statuses";
          break;

        case "type":
          dataset = "types";
          break;

        case "subtype":
          dataset = "subtypes";
          break;

        case "resort":
          result = this.get_resort_name(value);
          break;
      }

      if (!result && dataset) {
        let index;

        for (
          index = 0;
          index < this.$store.state.datasets[dataset].length;
          index++
        ) {
          if (this.$store.state.datasets[dataset][index].id === value) {
            result = this.$store.state.datasets[dataset][index].name;

            if (to_lowercase) {
              result = result.toString().toLowerCase();
            }
            break;
          }
        }
      }

      return result ? result : "Any";
    },

    get_resort_name: function (id) {
      let index;
      let name = "";

      if (id < 0) {
        switch (id) {
          case -10:
            name = "Any DVC";
            break;

          /* case -20 :
                          name    = 'Any MVC';
                          break; */
        }
      } else {
        for (
          index = 0;
          index < this.$store.state.datasets.resorts.length;
          index++
        ) {
          if (this.$store.state.datasets.resorts[index].id === id) {
            name = this.$store.state.datasets.resorts[index].name;
            break;
          }
        }
      }

      return name ? name : "Any Resort";
    },
  },
};
</script>
